import { pList, rIstatistikSonuc_4, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError, IKeyValPair } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';
import { SonucListesi } from '../../../../api/models/rIstatistikSonuc_3';

export const action_api_set_input = (body: pList | null | undefined): IInputAction<pList> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER, true, body);

export const action_async_start_promise = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER,
    new Api.Stat.OyakDegerleme.Toplam().Request(body),
    false,
    true,
    body
  );

export const action_async_complete_api = (
  data: rValue<rIstatistikSonuc_4> | null | undefined,
  error: IError | null | undefined
): IApiAction<rIstatistikSonuc_4> =>
  ActionFunctions.action_async_complete_api<rIstatistikSonuc_4>(
    ActionSubTypes.API_OYAKDEGERLEMETOPLAMDEGER,
    new rIstatistikSonuc_4({
      SonucListesi: ((data?.Value?.SonucListesi as unknown) as IKeyValPair[]) || [],
      AnahtarTuru: '',
      DegerTuru: '',
      Yillar: data?.Value?.Yillar || [],
      Toplam: data?.Value?.Toplam || 0,
    }),
    error
  );
